import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { AppModule } from "./app.module";

export const appConfig: ApplicationConfig = {
  providers: [importProvidersFrom(AppModule)],
};
